import { useEffect } from "react";
import { App } from "antd";
import sadUserIMG from "assets/pngImages/sad-user.png";
import styles from "./style.module.scss";

interface UnavailableModalProps {
  onClose: () => void;
  description?: React.ReactElement;
  actionText: string;
}

export default function UnavailableModal({
  onClose,
  description,
  actionText,
}: UnavailableModalProps) {
  const { modal } = App.useApp();

  useEffect(() => {
    const instance = modal.warning({
      title: "This feature is unavailable",
      content: (
        <div className={styles.unavailable}>
          <img src={sadUserIMG} alt="User with no views" />
          {description}
        </div>
      ),
      width: 480,
      okText: actionText,
      closable: true,
      afterClose: () => {
        onClose();
      },
    });

    return () => {
      instance.destroy();
    };
  }, [modal, description, actionText, onClose]);

  return null;
}
